export function currency(value) {
    // price integer de centavos. ex: 1000 = 10,00
    value = Number(value) / 100
    let string = value.toFixed(2)
    string = string.replace('.', ',')
    return 'R$' + string
}

export function productUnitPrice(product) {
    return Number(product.effective_price ?? product.price ?? 0)
}

export function productListPrice(product) {
    return Number(product.list_price ?? product.price ?? 0)
}

export function productOnSale(product) {
    return product.on_sale === true && productUnitPrice(product) < productListPrice(product)
}
